import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import "./index.scss";

export const CheckoutSummaryOrder = ({
  order: { subTotal, total, totalSavings }
}) => {
  return (
    <div
      className="checkout-summary-order"
      data-testid="checkout-summary-order"
    >
      {!!subTotal && (
        <div className="checkout-row checkout-subtotal">
          <p className="checkout-label">Subtotal:</p>
          <p className="checkout-value">
            {toMoneyWithTwoDecimalDigits(subTotal)}
          </p>
        </div>
      )}
      {!!total && (
        <div className="checkout-row checkout-total">
          <p className="checkout-label">Total:</p>
          <p className="checkout-value">{toMoneyWithTwoDecimalDigits(total)}</p>
        </div>
      )}
      {!!totalSavings && (
        <div className="checkout-row checkout-savings">
          <p className="checkout-label">Your savings:</p>
          <p className="checkout-value">
            {toMoneyWithTwoDecimalDigits(totalSavings)}
          </p>
        </div>
      )}
    </div>
  );
};
